<script>
import orBreak from "../common/orBreak.vue";
import equipmentTable from "../cost breakdown/equipmentTable.vue";

export default {
  name: "cost-breakdown-table",
  components: {
    orBreak,
    equipmentTable,
  },
  props: {
    offerCostBreakdown: Object,
  },
  data: () => ({
    costBreakdown: {
      OfferCostBreakdownId: emptyGuid(),
      OfferId: null,
      Items: [],
      Revision: null,
      Created: null,
      Modified: null,
      CreatedBy: "",
      ModifiedBy: "",
    },
  }),
  methods: {
    async updateItems() {
      await this.$emit("updated", this.costBreakdown);
    },

    setDefaultCostBreakdown() {
      this.costBreakdown = {
        OfferCostBreakdownId: emptyGuid(),
        OfferId: null,
        Items: [],
        Revision: null,
        Created: null,
        Modified: null,
        CreatedBy: "",
        ModifiedBy: "",
      };
    },
  },

  watch: {
    offerCostBreakdown: {
      handler(val) {
        if (val) {
          this.costBreakdown = val;
        } else {
          this.setDefaultCostBreakdown();
        }
      },
      deep: true,
    },
    "costBreakdown.Items"() {
      this.updateItems();
    },
  },

  async mounted() {},
};
</script>
<template>
  <equipment-table :items.sync="costBreakdown.Items" :hide-costs="false"></equipment-table>
</template>
